<template>
  <qx-card title="列表">
    <FileDialog ref="fileDialog" @sub="getData" />
    <SettlementDialog ref="settlementDialog" @sub="getData" />
    <i
      class="el-icon-question cur warning introBtn"
      slot="titleLeft"
      @click="showIntroDialog"
    />
    <IntroDialog ref="introDialog" />
    <EditDialog ref="editDialog" @sub="getData" />
    <LogRightDialog ref="logRightDialog" busiCode="220000001" />
    <ImportBtn
      :title="uploadList[activeUploadIndex].title"
      :fileUrl="uploadList[activeUploadIndex].fileUrl"
      ref="importBtn"
      :noShow="true"
      :customPost="true"
      :isCustomDownload="true"
      @customDownload="customDownload"
      @sub="importPost"
    />
    <section slot="titleRight">
      <qx-permpisions permpisions="6000901">
        <el-button
          type="primary"
          plain
          @click="sendBill(tableData.selectResult)"
          >发送工资单</el-button
        >
      </qx-permpisions>
      <qx-permpisions permpisions v-show="checkPermpisions('6000903') || checkPermpisions('6000904') ||checkPermpisions('6000905') ||checkPermpisions('6000906')">
        <el-dropdown>
          <el-button type="primary" plain>
            <i class="iconfont">&#xe6ac;</i>批量
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <qx-permpisions v-for="(item, index) in uploadList" :key="index">
              <el-dropdown-item
                @click.native="showImport(index)"
                v-if="checkPermpisions(item.permpisions)"
              >
                {{ item.label }}
              </el-dropdown-item>
            </qx-permpisions>
          </el-dropdown-menu>
        </el-dropdown>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <el-dropdown>
          <el-button type="primary" plain>
            <i class="iconfont">&#xe6ad;</i>导出
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <qx-permpisions v-for="(item, index) in exportList" :key="index">
              <el-dropdown-item @click.native="exportData(index)">
                {{ item.label }}
              </el-dropdown-item>
            </qx-permpisions>
          </el-dropdown-menu>
        </el-dropdown>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <ExportBtn
            :len="tableData.data.length"
            queryUrl="cmSalaryInfoNewBO.ajax?cmd=getSalaryOrderList"
            :params="fullSearchData"
            bizName="工资订单数据"
            bizCode="exp202204"
            :excelKeys="downloadParams.excelKeys"
            :excelLables="downloadParams.excelLables"
            btnName="导出订单数据"
        />
      </qx-permpisions>

      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <el-table-column type="selection" width="55" />
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'carDriverName'"
                  @click="toDriverDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section
                  v-else-if="
                    scope.column.property === 'orderCount' &&
                    scope.row.orderCount !== 0
                  "
                  @click="toDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section v-else-if="scope.column.property === 'orderDeductionDouble'">
                  {{ formatOrderDeduction(scope.row[scope.column.property]) }}
                </section>
                <section
                  v-else-if="scope.column.property === 'complainCount'"
                  @click="toComplainCountDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section
                  v-else-if="scope.column.property === 'answerSubsidyFeeDouble'"
                  @click="toSubsidy(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section v-else>{{ scope.row[scope.column.property] }}</section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            fixed="right"
            width="140"
            key="slot"
          >
            <template #default="scope">
              <section>
                <qx-permpisions
                  permpisions="6000902"
                  v-if="scope.row.state === 3 || scope.row.state === 4"
                >
                  <span
                    class="primary cur"
                    @click="showSettlementDialog(scope.row)"
                    >结算</span
                  >
                </qx-permpisions>
                <qx-permpisions
                  permpisions="6000911"
                  v-if="scope.row.state === 2"
                >
                  <span class="primary cur" @click="sure(scope.row)">确认</span>
                </qx-permpisions>
                <qx-permpisions permpisions="6000910">
                  <span class="primary cur" @click="showEditDialiog(scope.row)"
                    >修改</span
                  >
                </qx-permpisions>
                <qx-permpisions permpisions>
                  <span class="primary cur" @click="showLog(scope.row.salaryId)"
                    >日志</span
                  >
                </qx-permpisions>
                <!-- 操作按钮 end -->
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import { downloadBinaryFile } from 'api';
import {
  jsonParamsToUrlParams,
} from '@qx/utils';
import tableMixin from '@qx/mixin/table';
import EditDialog from './editDialog';
import LogRightDialog from 'components/logRightDialog';
import ImportBtn from 'components/importBtn';
import IntroDialog from './introDialog';
import SettlementDialog from './settlementDialog';
import FileDialog from './fileDialog';
import TableSetting from 'components/tableSetting/tableSetting';
import ExportBtn from 'components/exportBtn';
import {
  driverSalaryList,
  setDriverSendBill,
  importUpdate,
  driverSalarySure,
  driverSalaryListName,
} from 'api/getPay';
import {mapState} from 'vuex';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    FileDialog,
    LogRightDialog,
    EditDialog,
    ImportBtn,
    IntroDialog,
    SettlementDialog,
    TableSetting,
    ExportBtn,
  },
  data () {
    return {
      downloadParams: {
        excelKeys: '',
        excelLables: '',
      },
      activeUploadIndex: 0,
      uploadList: [
        {
          permpisions: '6000903',
          label: '修改工资单',
          name: 'modify',
          title: '批量修改工资单',
          fileUrl: '/file/司机修改工资单数据.xlsx',
          exportTemplateUrl: '/cmSalaryInfoNewBO.ajax?cmd=exportForModify',
          batchImportUrl: '/cmSalaryInfoNewBO.ajax?cmd=modifySalaryInfoByExcel',
        },
        {
          permpisions: '6000904',
          label: '发送工资单',
          name: 'sendPayroll',
          title: '批量发送工资单',
          fileUrl: '/file/司机确认（发送）工资单模板.xlsx',
          exportTemplateUrl: '/cmSalaryInfoNewBO.ajax?cmd=exportTemplate',
          batchImportUrl: '/cmSalaryInfoNewBO.ajax?cmd=opBillByExcel&operType=2',
        },
        {
          permpisions: '6000905',
          label: '确认工资单',
          name: 'payrollComfirm',
          title: '批量确认工资单',
          fileUrl: '/file/司机确认（发送）工资单模板.xlsx',
          exportTemplateUrl: '/cmSalaryInfoNewBO.ajax?cmd=exportTemplate',
          batchImportUrl: '/cmSalaryInfoNewBO.ajax?cmd=opBillByExcel&operType=3',
        },
        {
          permpisions: '6000906',
          label: '结算工资单',
          name: 'settlePayroll',
          title: '批量导入工资结算',
          fileUrl: '/file/司机结算工资单模板.xlsx',
          exportTemplateUrl: '/cmSalaryInfoNewBO.ajax?cmd=exportTemplate',
          batchImportUrl: '/cmSalaryInfoNewBO.ajax?cmd=checkSalaryInfoByExcel',
        },
      ],
      exportList: [
        {
          label: '工资数据',
          name: 'salaryData',
          title: '导出工资数据',
          exportUrl: '/cmSalaryInfoNewBO.ajax?cmd=exportSalaryInfo',
          exportParams: {
            checkSts: -1,
            salaryComplainSts: -1,
          },
        },
        // {
        //   label: '工资申诉',
        //   name: 'salaryAppeal',
        //   title: '导出工资申诉',
        //   exportUrl: '/cmSalaryInfoNewBO.ajax?cmd=exportAllSalaryComplain',
        // },
        // {
        //   label: '订单数据',
        //   name: 'orderData',
        //   title: '导出订单数据',
        //   exportUrl: '/cmSalaryInfoNewBO.ajax?cmd=exportAllSalaryOrders',
        // },
      ],
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        selectTar: 'salaryId',
        title: [ // 表头
          // { prop: 'settleMonth', label: '结算月份', fixed: true },
          // { prop: 'carDriverName', label: '司机姓名' },
          // { prop: 'carDriverPhone', label: '司机手机号码' },
          // { prop: 'orderCount', label: '订单数' },
          // { prop: 'monthMileageStr', label: '月里程' },
          // { prop: 'basicSalaryFeeDouble', label: '基本工资' },
          // { prop: 'orderBaseSalaryFeeDouble', label: '订单工资' },
          // { prop: 'subsidyFeeDouble', label: '月补贴' },
          // { prop: 'tripPayFeeDouble', label: '趟数工资' },
          // { prop: 'mileagePayFeeDouble', label: '里程工资' },
          // {prop: 'moneyValuePayDouble', label: '出车款剩余金额'},
          // { prop: 'saveOilBonusDouble', label: '节油奖' },
          // {prop: 'orderSubsidyDouble', label: '订单补贴'},
          // { prop: 'answerSubsidyFeeDouble', label: '已发补贴' },
          // { prop: 'lastMonthDebtDouble', label: '上月欠款' },
          // { prop: 'remark', label: '备注' },
          // { prop: 'stateName', label: '状态' },
          // { prop: 'realSalaryFeeDouble', label: '实发工资' },
          // { prop: 'paidSalaryFeeDouble', label: '已结算工资' },
          // { prop: 'checkDate', label: '结算时间' },
          // { prop: 'complainCount', label: '申诉数量' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  watch: {
    'tableData.data': function (val) {
      this.$nextTick(() => {
        this.$refs.multipleTable.doLayout();
      });
    },
    'tableData.title': function (val) {
      this.$nextTick(() => {
        this.$refs.multipleTable.doLayout();
      });
    },
  },
  methods: {
    getList: driverSalaryList,
    showFileDialog (item) {
      this.$refs.fileDialog.show(item);
    },
    showIntroDialog () {
      this.$refs.introDialog.show();
    },
    formatOrderDeduction (value) {
      const amount = Number(value);
      if (!Number.isFinite(amount) || amount === 0) {
        return '0.00';
      }
      return `-${Math.abs(amount).toFixed(2)}`;
    },
    toDriverDetail (item) {
      this.jump({
        label: '司机详情',
        url: `/manage/archives/driver/archives/detail?id=${item.carDriverId}`,
        full: true,
      });
    },
    toSubsidy (item) {
      this.jump({
        label: '已发补贴',
        url: `/manage/getPay/writeOff/driver/subsidy?id=${item.salaryId}`,
        full: true,
      });
    },
    showSettlementDialog (item) { // 结算
      this.$refs.settlementDialog.show(item);
    },
    // 导入修改
    showImport (activeUploadIndex) {
      this.activeUploadIndex = activeUploadIndex;
      this.$refs.importBtn.showImportDialog();
    },
    setImportExportParams (data) {
      // 把查询参数添加到 url 上面
      for (let item of this.uploadList) {
        item.exportTemplateUrlWithParams = `${item.exportTemplateUrl}&${jsonParamsToUrlParams(data)}`;
        if (item.name === 'sendPayroll') {
          item.exportTemplateUrlWithParams += '&templateType=2';
        } else if (item.name === 'payrollComfirm') {
          item.exportTemplateUrlWithParams += '&templateType=3';
        } else if (item.name === 'settlePayroll') {
          item.exportTemplateUrlWithParams += '&templateType=4';
        }
      }
      for (let item of this.exportList) {
        item.exportWithParams = `${item.exportUrl}&${jsonParamsToUrlParams(data)}`;
      }
    },
    customDownload () {
      const currentTarget = this.uploadList[this.activeUploadIndex];
      downloadBinaryFile({
        url: currentTarget.exportTemplateUrlWithParams,
        fileName: currentTarget.fileUrl.replace(/\/file\//g, ''),
      });
    },
    // 直接导出二进制文件
    async exportData (activeExportIndex) {
      const currentTarget = this.exportList[activeExportIndex];
      const res = await downloadBinaryFile({
        url: currentTarget.exportWithParams,
        fileName: `${currentTarget.label}.xlsx`,
      });
      if (!res.failed) {
        this.$message.success('操作成功');
      } else {
        this.$confirm(res.message, '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false,
        });
      }
    },
    async importPost (data) {
      const res = await importUpdate(
        this.uploadList[this.activeUploadIndex].batchImportUrl,
        {
          mySalaryFile: data.file,
        });
      if (!res.failed) {
        this.$message.success('保存成功');
        this.getData();
      } else {
        this.$confirm(res.message, '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showCancelButton: false,
        });
      }
    },
    toDetail (item) {
      this.jump({
        label: '工资详情',
        url: `/manage/getPay/writeOff/driver/detail?id=${item.salaryId}&settleMonth=${this.searchBoxData.settleMonth}`,
        full: true,
      });
    },
    toComplainCountDetail (item) {
      this.jump({
        label: '申诉详情',
        url: '/manage/getPay/writeOff/driver/complaint?salaryId=' +
          item.salaryId +
          '&carDriverId=' + item.carDriverId +
          '&carDriverPhone=' + item.carDriverPhone +
          '&settleMonth=' + this.searchBoxData.settleMonth +
          '&carDriverName=' + encodeURIComponent(item.carDriverName),
        full: true,
      });
    },
    async sendBill (arr) { // 发送工资单
      if (arr.length === 0) {
        this.$message.warning('请先选择操作对象');
        return;
      }
      const salaryIds = arr.map((item) => item.salaryId);
      const res = await setDriverSendBill({
        salaryIds: salaryIds.join(','),
      });
      if (!res.failed) {
        this.$message.success('发送成功');
        this.getData();
      }
    },
    showEditDialiog (item) { // 修改
      this.$refs.editDialog.show(item);
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
    async sure (item) {
      const confirmRes = await this.$confirm('是否确定工资?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await driverSalarySure({
          salaryId: item.salaryId,
        });
        if (!res.failed) {
          this.$message.success('确认成功');
          this.getData();
        }
      }
    },
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo, // 用户信息

    }),
  },
  async mounted () {
    var _this = this;
    const res = await driverSalaryListName({
      settleMonth: this.searchBoxData.settleMonth,
      channelType: 'WEB',
    });
    if (!res.failed) {
      let data = [];
      res.items.map((item) => {
        if (item.prop === 'settleMonth') {
          item.fixed = true;
        }
        item.show = true;
        data.push(item);

      });
      if (!data.some((item) => item.prop === 'orderDeductionDouble')) {
        const orderCountIndex = data.findIndex((item) => item.prop === 'orderCount');
        data.splice(orderCountIndex >= 0 ? orderCountIndex + 1 : data.length, 0, {
          prop: 'orderDeductionDouble',
          label: '订单扣款',
          minW: 100,
          show: true,
        });
      }
      this.tableData.title = data;
    }

    const res1 = await driverSalaryListName({
      settleMonth: this.searchBoxData.settleMonth,
      channelType: 'WEB-details',
    });
    if (!res1.failed) {
      res1.items.map((item) => {
        // 初始化导出订单数据的表头内容
        _this.downloadParams.excelKeys += item.prop + ',';
        _this.downloadParams.excelLables += item.label + ',';
      }
      );
      _this.downloadParams.excelKeys = _this.downloadParams.excelKeys.substring(0, _this.downloadParams.excelKeys.length - 1);
      _this.downloadParams.excelLables = _this.downloadParams.excelLables.substring(0, _this.downloadParams.excelLables.length - 1);
    }
  },
};
</script>

<style lang="scss" scoped>
.introBtn {
  margin-left: 16px;
}
.control {
  span {
    margin-right: 8px;
  }
}
</style>
